import type { SVGProps } from 'react';

const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
    <g clipPath="url(#copy_svg__a)">
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.624}
        d="M6.75 18.437H4.125A2.625 2.625 0 0 1 1.5 15.81v-10.5a2.625 2.625 0 0 1 2.625-2.624h10.5a2.625 2.625 0 0 1 2.625 2.625v2.625m-7.875 15.75h10.5A2.625 2.625 0 0 0 22.5 21.06v-10.5a2.625 2.625 0 0 0-2.625-2.624h-10.5a2.625 2.625 0 0 0-2.625 2.625v10.5a2.625 2.625 0 0 0 2.625 2.624"
      />
    </g>
    <defs>
      <clipPath id="copy_svg__a">
        <path fill="#fff" d="M0 .687h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCopy;
